import React from 'react';

/**
 * Apple Inc. logo (bitten apple).
 *
 * Drop-in replacement for `lucide-react`'s generic apple-fruit icon so the
 * Apple Pay buttons across the customer flow render with the brand glyph
 * customers actually recognise. Same `className` API as Lucide so it
 * swaps in without other code changes.
 *
 * Path is the Wikipedia Commons "Apple_logo_black.svg" outline, simplified
 * and re-bezier'd to fit Lucide's 24×24 viewBox so stroke-width / sizing
 * matches the rest of the icon set.
 */
export default function AppleLogo({ className = '', size, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      fill="currentColor"
      aria-hidden="true"
      {...rest}
    >
      <path d="M17.05 12.04c-.03-3.05 2.49-4.52 2.6-4.59-1.42-2.07-3.62-2.35-4.41-2.38-1.88-.19-3.66 1.1-4.61 1.1-.96 0-2.42-1.08-3.98-1.05-2.05.03-3.94 1.19-4.99 3.02-2.13 3.69-.54 9.13 1.52 12.12.99 1.46 2.18 3.1 3.74 3.04 1.5-.06 2.07-.97 3.88-.97 1.81 0 2.32.97 3.91.94 1.61-.03 2.63-1.49 3.61-2.95 1.14-1.69 1.61-3.33 1.63-3.42-.04-.02-3.12-1.2-3.15-4.76zM14.27 4.31c.83-1.01 1.4-2.41 1.24-3.81-1.2.05-2.66.8-3.52 1.8-.77.89-1.45 2.32-1.27 3.69 1.34.1 2.71-.68 3.55-1.68z" />
    </svg>
  );
}
